'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _Slider2 = require('./Slider');

var _Slider3 = _interopRequireDefault(_Slider2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Slider = _Slider3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Slider/index.js
// module id = 1637
// module chunks = 0